import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

const UsedPhoneAttributeGroupsPage = React.lazy(() => import('pages/UsedPhoneMasterData/pages/UsedPhoneAttributeGroupsPage'));
const UsedPhoneAttributesPage = React.lazy(() => import('pages/UsedPhoneMasterData/pages/UsedPhoneAttributesPage'));
const UsedPhoneCodeRuleTypesPage = React.lazy(() => import('pages/UsedPhoneMasterData/pages/UsedPhoneCodeRuleTypesPage'));
const UsedPhoneCodeRulesPage = React.lazy(() => import('pages/UsedPhoneMasterData/pages/UsedPhoneCodeRulesPage'));

function UsedPhoneMasterDataRedirectPage() {
  const history = useHistory();

  useEffect(() => {
    history.replace('/used-phone-attribute-groups');
  }, [history]);

  return null;
}

const usedPhoneMasterDataRoute = [
  {
    path: '/used-phone-master-data',
    exact: true,
    name: 'Master data máy cũ',
    function: 'ST_STOCKSINREQUEST_VIEW',
    component: UsedPhoneMasterDataRedirectPage,
  },
  {
    path: '/used-phone-attribute-groups',
    exact: true,
    name: 'Nhóm thuộc tính máy cũ',
    function: 'ST_STOCKSINREQUEST_VIEW',
    component: UsedPhoneAttributeGroupsPage,
  },
  {
    path: '/used-phone-attributes',
    exact: true,
    name: 'Thuộc tính máy cũ',
    function: 'ST_STOCKSINREQUEST_VIEW',
    component: UsedPhoneAttributesPage,
  },
  {
    path: '/used-phone-code-rule-types',
    exact: true,
    name: 'Loại quy tắc mã',
    function: 'ST_STOCKSINREQUEST_VIEW',
    component: UsedPhoneCodeRuleTypesPage,
  },
  {
    path: '/used-phone-code-rules',
    exact: true,
    name: 'Quy tắc mã',
    function: 'ST_STOCKSINREQUEST_VIEW',
    component: UsedPhoneCodeRulesPage,
  },
];

export default usedPhoneMasterDataRoute;
